import React, { useState } from 'react';
import styled from 'styled-components';
import { TextInput, Icon } from 'react-orange-ui';

// Position the icon in input field
const Wrapper = styled.div`
  position: relative;
  
  & > svg {
    position: absolute;
    top: 4px;
    right: 8px;
    cursor: pointer;
    z-index: 1;
  }
`;

const PasswordInput = React.forwardRef((props, ref) => {
  const [type, setType] = useState('password');

  const onKeyPress = (event) => {
    if (event.key === ' ') {
      setType(type === 'password' ? 'text' : 'password');
    }
  };

  return (
    <Wrapper>
      <TextInput
        ref={ref}
        type={type}
        {...props}
      />
      <Icon
        id={`icon-reveal-${props.id}`}
        className={type === 'text' ? 'open' : 'closed'}
        role="button"
        aria-pressed={type === 'text'}
        aria-label="Afficher ou cacher le mot de passe"
        tabIndex={0}
        onKeyDown={onKeyPress}
        onClick={() => setType(type === 'password' ? 'text' : 'password')}
        icon={type === 'text' ? 'accessibility-vision' : 'Hide'}
        color="black"
        width={28}
        height={28}
      />
    </Wrapper>
  );
});

export default PasswordInput;
